import React from 'react'
import StatusDropdown from '../../components/StatusDropdown';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import Header from '../../components/Header';
import OwnerSidebar from '../../components/owner/OwnerSidebar';


import { Link } from 'react-router-dom';
import DropdownSVG from '../../components/OrderDropdown';
import GratuityStatusCard from '../../components/owner/GratuityStatusCard';


// laundry status data
const laundryStatus = [
    { label: 'All', link: '#' },
    { label: 'Binned', link: '#' },
    { label: 'Washing', link: '#' },
    { label: 'Drying', link: '#' },
    { label: 'Folding', link: '#' },
  ];

  const options = [
    { label: 'Edit Order', link: '#' },
    { label: 'Duplicate Order', link: '#' },
    { label: 'Print Details', link: '#' },
    { label: 'Archive Orders', link: '#' }
  ];

const GratuityScreen = () => {

    const tabs = [
        {
         
          tableData: [
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Phoebe Buffay', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Ross Geller', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Joey Tribbiani', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Phoebe Buffay', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details' },
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Phoebe Buffay', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
            { tipCollected: '$14.00', orderNo: '#108', orderAmount: '$40.00', employeeName: 'Phoebe Buffay', dateCollected: '06/27/23', viewButton: '/owner/reports/invoicing/invoicing-details'},
          ]
        },
    
         
      ];

  return (
    <>
      <section className='dashboard-container flex '>
        <aside className=''>
        <OwnerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Gratuity'} orderSubtitle={'View record of employee tips'} showButton={false} /> 
          <section>
          <section className='mt-10 flex gap-10'>
            <GratuityStatusCard statusTitle={'Tips collected'} noOfOrdersClassName={'custom-style'} salesRevenue={'$ 14,730.72'} noOfOrders={23} dropDown={<StatusDropdown options={laundryStatus} dropdownText={'All Employees'} className="" />} dropDown2={<StatusDropdown options={laundryStatus} dropdownText={'All Time'} className="" />} />
            
        </section>
    

        <div className="tab-container mt-10">
            <section className='flex search-filter-section mt-4 mb-4 ml-4'>
                <section>
                    <form action="">
                        <label htmlFor="" className="flex flex-col order-search-input">
                            <SearchIcon className='order-search-icon search-icon'/>
                            <input type="text" placeholder="Search" className="mt-2"/>
                        </label>
                    </form>
                </section>
                <section className='flex gap-10 ml-20'>
                    <div className='flex gap-4'>
                        <FilterIcon/>
                        <p className='filter-section-text'>Filter</p>

                    </div>
                    <div className='flex gap-4'>
                        <ExportIcon/>
                        <p className='filter-section-text'>Export as csv</p>
                        
                    </div>
                </section>
            </section>    
            

            <div className="tab-content">
                {tabs.map((tab, index) => (
                <div key={index} className={``}>
                    <table className="custom-table custom-order-table">

                    <thead>
                        <tr className='table-head'>
                        <th>
                            Tip collected
                            <span className="filter-icon">
                            <ActiveIcon />
                            </span>
                        </th>

                        <th className=''>
                            Order No.
                            <span className="filter-icon">
                            <ActiveIcon className=''/>
                            </span>
                        </th>

                        <th>
                            Order amount
                            <span className="filter-icon">
                            <ActiveIcon />
                            </span>
                        </th>
                      

                        <th>
                            Employee name
                            <span className="filter-icon">
                                <ActiveIcon />
                            </span>
                        </th>

                        <th>
                            Date collected
                            <span className="filter-icon">
                                <ActiveIcon />
                            </span>
                        </th>
                        </tr>
                    </thead>

                    <tbody className='table-body'>
                        {tab.tableData.map((data, dataIndex) => (
                        <tr key={dataIndex} className='table-row'>
                             <td className='table-data'>
                            {data.tipCollected}
                            
                            </td>

                            <td className='table-data-1'>
                            {data.orderNo}
                           
                            </td>

                            <td className='table-data'>
                            {data.orderAmount}
                            
                            </td>
                        
                            
                        
                            <td className='table-data'>
                            {data.employeeName}
                        
                            </td>
                         
                            
                            <td className='table-data'>
                            {data.dateCollected}
                        
                            </td>
                            <td>
                                <Link to={data.viewButton} className='view-btn'>View</Link>
                            </td>
                            <td>
                            <DropdownSVG options={options} className="my-dropdown" />
                            </td>
                            
                        </tr>
                        ))}
                    </tbody>
                    </table>
                </div>
                ))}
            </div>
            </div>
          </section>
        </main>
      </section>
        
    </>
  )
}

export default GratuityScreen